<template>
    <div style="display: inline-block; width: 100%;">
        <label>{{text}}</label>
        <RequiredLabel v-show="required"/>
        <OptionalLabel v-show="optional"/>
        <span class="padding-left-20">
            <el-tag v-if="validationTip" type="danger">{{validationTip}}</el-tag>
        </span>
    </div>
</template>

<script>
    export default {
        name: "InputLabel",
        props: {
            text: {
                type: String,
                required: true
            },
            validationTip: {
                type: String,
                required: false
            },
            required: {
                type: Boolean,
                required: false,
                default: false
            },
            optional: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>
